import { NavigateFunction } from 'react-router-dom';
import ROUTES from '../../constants/routes';
import axios from '../axios';
import errorTracker from '../error-tracker';

export const FREE_DOWNLOAD_KINDS = {
    FRESH: 'fresh',
    REPEAT: 'repeat'
} as const;

export type FreeDownloadKind = (typeof FREE_DOWNLOAD_KINDS)[keyof typeof FREE_DOWNLOAD_KINDS];

export type FreeThankYouNavigationState = {
    downloadKind: FreeDownloadKind;
};

type NavigateFreeThankYouArgs = {
    materialId: number;
    navigate: NavigateFunction;
    downloadKind?: FreeDownloadKind;
};

const acquiredMaterialIds = new Set<number>();

const resolveDownloadKind = (isNewAccess: unknown, fallbackKind: FreeDownloadKind): FreeDownloadKind => {
    if (typeof isNewAccess !== 'boolean') {
        return fallbackKind;
    }

    return isNewAccess ? FREE_DOWNLOAD_KINDS.FRESH : FREE_DOWNLOAD_KINDS.REPEAT;
};

const navigateFreeThankYou = ({
    materialId,
    navigate,
    downloadKind = FREE_DOWNLOAD_KINDS.FRESH
}: NavigateFreeThankYouArgs) => {
    const isAlreadyAcquired = acquiredMaterialIds.has(materialId);

    return axios
        .get(`v1/order/free-material/request/${materialId}`, { params: { directLink: true } })
        .then((res) => {
            const { isNewAccess, token } = res?.data?.items ?? {};
            const fallbackKind = isAlreadyAcquired ? FREE_DOWNLOAD_KINDS.REPEAT : downloadKind;
            const state: FreeThankYouNavigationState = {
                downloadKind: resolveDownloadKind(isNewAccess, fallbackKind)
            };

            if (token) {
                acquiredMaterialIds.add(materialId);
            }

            navigate(`${ROUTES.FREE_DOWNLOAD.path.replace(':token', token)}`, { state });
        })
        .catch((error) => {
            errorTracker.captureException(error instanceof Error ? error : new Error('Free material request failed'));
        });
};

export default navigateFreeThankYou;
